"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ScreenType;
(function (ScreenType) {
    ScreenType["DEPOSIT"] = "deposit";
    ScreenType["BASE_RATE"] = "base rate";
    ScreenType["WHATS_INCLUDED"] = "whats included";
    ScreenType["APPLY_TAXES"] = "apply taxes";
    ScreenType["SELECT_TEXES"] = "select texes";
    ScreenType["CLEANING_FEE"] = "cleaning fee";
    ScreenType["FUEL_NOT_INCLUDED"] = "fuel not included";
    ScreenType["FUEL_INCLUDED"] = "fuel included";
    ScreenType["PAYOUT_ESTIMATION"] = "payout estimation";
    ScreenType["SELECT_PAYEE"] = "select payee";
    ScreenType["EXTRA_GUEST_FEE"] = "extra guest fee";
    ScreenType["OPTIONAL_ADD_ON"] = "optional add on";
})(ScreenType = exports.ScreenType || (exports.ScreenType = {}));
